module.exports = __webpack_public_path__ + "static/media/banner-rrajesh.211e7cab.jpg";